package pl.decks.personal.components.layouts.blog

import com.varabyte.kobwebx.frontmatter.FrontMatterElement

data class BlogPostData(
    val title: String,
    val description: String?,
    val heroImage: String?,
    val date: String?,
    val author: String,
    val tags: List<String>,
) {
    companion object {
        fun fromFrontMatter(fm: FrontMatterElement.ValueMap): BlogPostData = BlogPostData(
            title = fm["title"]?.singleOrNull() ?: throw Exception(), // TODO: Proper Exception handling
            description = fm["description"]?.singleOrNull(),
            heroImage = fm["heroImage"]?.singleOrNull(),
            date = fm["date"]?.singleOrNull(),
            author = fm["author"]?.singleOrNull() ?: "@me",
            tags = fm["tags"] ?: emptyList(),
        )
    }
}
